var map = {
	"./en/common.json": [
		54749,
		749
	],
	"./en/customer.json": [
		44280,
		280
	],
	"./en/menu.json": [
		16103,
		103
	],
	"./en/notification.json": [
		53543,
		543
	],
	"./en/order.json": [
		6080,
		80
	],
	"./en/product.json": [
		14375,
		375
	],
	"./en/production_cost.json": [
		70893,
		893
	],
	"./th/common.json": [
		41244,
		244
	],
	"./th/customer.json": [
		57725,
		725
	],
	"./th/menu.json": [
		88342,
		342
	],
	"./th/notification.json": [
		28210,
		210
	],
	"./th/order.json": [
		63431,
		431
	],
	"./th/product.json": [
		90916,
		916
	],
	"./th/production_cost.json": [
		24154,
		154
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64766;
module.exports = webpackAsyncContext;